import { render, staticRenderFns } from "./ViewsDialog.vue?vue&type=template&id=32a31c26&"
import script from "./ViewsDialog.vue?vue&type=script&lang=js&"
export * from "./ViewsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports